export default "__VITE_PUBLIC_ASSET__23ab9b2b__"